import { render, staticRenderFns } from "./RoomFacilityForm.vue?vue&type=template&id=27dccc3a&scoped=true"
import script from "./RoomFacilityForm.vue?vue&type=script&lang=js"
export * from "./RoomFacilityForm.vue?vue&type=script&lang=js"
import style0 from "./RoomFacilityForm.vue?vue&type=style&index=0&id=27dccc3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dccc3a",
  null
  
)

export default component.exports